import React, { useState, useEffect } from "react";
import logo from "../../../assets/images/logo-white.png";
import { Input, Modal, notification, Table } from "antd";
import { GET } from "../../../utils/apiRequest";
import { LoadingOutlined } from "@ant-design/icons";
import { IoMdSearch } from "react-icons/io";
import { AiOutlineScan } from "react-icons/ai";
import { Html5QrcodeScanner } from "html5-qrcode";
import "../styles.scss";
import { API } from "../../../config/Api";

function Card(props: any) {
  const { Search } = Input;
  const [cardNo, setCardNo] = useState("");
  const [fullDetails, setFullDetails] = useState<any>({});

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [visible, setVisible] = useState(false);
  const [seachInputVisible, SetSeachInputVisible] = useState(true);
  const [cardModal, SetCardModal] = useState(false);

  const handleSearch = async (searchCardNo: any) => {
    setIsLoading(true);
    try {
      const response: any = await GET(
        API.CARD_REFERENCE_DATA_FOR_COMMISSION + searchCardNo
      );
      if (response?.status) {
        setFullDetails(response?.data);
        setVisible(false);
        SetCardModal(true);
        SetSeachInputVisible(false);
      } else {
        setFullDetails({});
        notification.error({
          message: "Card not found !",
          description:
            "Please check your card number or reach out to our staff.",
        });
        setError(true);
      }
    } catch (err) {
      notification.error({
        message: "Oops !",
        description: "Something went wrong. Please refresh and try again.",
      });
    }
    setIsLoading(false);
  };
  const qrCodeSuccessCallback = (decodedText: any) => {
    setCardNo(decodedText);
    handleSearch(decodedText);
  };

  const qrCodeErrorCallback = (errorMessage: any) => {
    console.error("Error scanning QR code:", errorMessage);
  };

  const handleOk = () => {
    setVisible(false);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  function getTotalAmount(transactions: any) {
    return transactions.reduce(
      (sum: any, transaction: any) => sum + Number(transaction.totalAmount),
      0
    );
  }

  const columns = [
    {
      title: "Card Number",
      dataIndex: "cardNo",
      key: "cardNo",
    },
    {
      title: "Total Amount",
      dataIndex: "totalAmount",
      key: "totalAmount",
    },
  ];

  useEffect(() => {
    if (visible) {
      const html5QrcodeScanner = new Html5QrcodeScanner(
        "html5qr-code-full-region",
        {
          fps: 10,
          qrbox: 250,
          aspectRatio: 1,
          disableFlip: false,
        },
        true
      );
      html5QrcodeScanner.render(qrCodeSuccessCallback, qrCodeErrorCallback);
      return () => {
        html5QrcodeScanner.clear().catch((error: any) => {
          console.error("Failed to clear html5QrcodeScanner. ", error);
        });
      };
    }
  }, [visible]);
  return (
    <>
      <div className="Share-cardBox">
        <div className="Share-cardInnerBox">
          <div className="Share-cardtxt1">LOYALTY CARD</div>
          <div style={{ padding: 7 }}>
            <img className="Share-cardLogo" src={logo} alt="Logo" />
          </div>
        </div>
        <div className="Share-cardtxt2">{fullDetails?.card?.cardNo}</div>
        {fullDetails?.card ? (
          <div className="Share-cardtxt5 mt-2">{fullDetails?.card?.name}</div>
        ) : error ? (
          <div className="Share-cardtxt7">Card Not Assigned</div>
        ) : (
          <div />
        )}
        <div className="Share-cardInnerBox">
          <div style={{ display: "flex", alignItems: "end", gap: 5 }}>
            <div style={{ display: "flex", width: "75%" }}>
              <Input
                placeholder="Enter cardNo"
                className="Share-searchInput"
                value={cardNo}
                onChange={(e) => setCardNo(e.target.value)}
                onPressEnter={() => handleSearch(cardNo)}
              />
              <div
                className="Share-searchIcon"
                onClick={() => handleSearch(cardNo)}
              >
                {isLoading ? (
                  <LoadingOutlined style={{ fontSize: 20 }} spin />
                ) : (
                  <IoMdSearch size={20} color="white" />
                )}
              </div>
            </div>
            <AiOutlineScan
              size={33}
              color="#08493e"
              onClick={() => setVisible(true)}
            />
          </div>
          <div>
            <div className="Share-cardtxt3">Balance</div>
            <div className="Share-cardtxt4">0.00</div>
          </div>
        </div>
      </div>

      {cardModal ? (
        <Modal
          title={`Card ${fullDetails?.card?.cardNo}`}
          closable={{ "aria-label": "Custom Close Button" }}
          open={cardModal}
          width={400}
          onOk={() => SetCardModal(false)}
          onCancel={() => SetCardModal(false)}
        >
          <div className="">
            <hr />
            <div className="" style={{ fontSize: "20px" }}>
              Total transactions: <b>{fullDetails?.transactions?.length}</b>
            </div>
            <div className="" style={{ fontSize: "20px" }}>
              Total Amounts: <b>{getTotalAmount(fullDetails?.transactions)}</b>
            </div>
            <hr />
            <Table
              columns={columns}
              dataSource={fullDetails?.transactions}
              rowKey="cardNo"
              bordered
              pagination={false}
            />
          </div>
        </Modal>
      ) : null}

      {visible ? (
        <Modal
          title="Scan QR Code"
          open={visible}
          onOk={handleOk}
          footer={false}
          onCancel={handleCancel}
        >
          <div id="html5qr-code-full-region" style={{ width: "100%" }} />
        </Modal>
      ) : null}
    </>
  );
}

export default Card;
